import { useQuery, useQueryClient, useSuspenseQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { PublicUserData } from 'src/shared/features/users/schemas/user'

export const getUserByUsername = (username: string, fromSearch = false) =>
  getRequest<PublicUserData>(`/users/lookup?username=${username}&from_search=${fromSearch}`)

export const useUserByUsername = (username: string, fromSearch = false) => {
  const queryClient = useQueryClient()

  return useSuspenseQuery({
    ...queries.users.detailByUsername(username),
    queryFn: async () => {
      if (!username) return null
      const response = await getUserByUsername(username, fromSearch)
      if (fromSearch) {
        await queryClient.invalidateQueries({ queryKey: queries.search._def })
      }
      return response
    },
    staleTime: 15 * 60 * 1000,
    retry: false,
  })
}

export const useUserByUsernameQuery = (username?: string, fromSearch = false) => {
  const queryClient = useQueryClient()

  return useQuery({
    ...queries.users.detailByUsername(username || ''),
    queryFn: async () => {
      if (!username) return null
      const response = await getUserByUsername(username, fromSearch)
      if (fromSearch) {
        await queryClient.invalidateQueries({ queryKey: queries.search._def })
      }
      return response
    },
    staleTime: 15 * 60 * 1000,
    retry: false,
    enabled: username !== undefined,
  })
}

export const useCheckForUser = (username: string, fromSearch = false) => {
  const queryClient = useQueryClient()

  return useQuery({
    ...queries.users.detailByUsername(username),
    queryFn: async () => {
      if (!username) return null
      const response = await getUserByUsername(username, fromSearch)
      if (fromSearch) {
        await queryClient.invalidateQueries({ queryKey: queries.search._def })
      }
      return response
    },
    staleTime: 15 * 60 * 1000,
    retry: false,
  })
}
